// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3gOGb","location":"Header_location__d4jk3"};